module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d10-7117fd902bbff8b264b563fcc3d20e42.jpg";